import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { authServices } from '../authServices'
import { RecoverPasswordDTO, RecoverPasswordPayload } from '../authTypes'
import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useRecoverPassword = (
  options?: IOptionsUseMutation<RecoverPasswordDTO>,
) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation<RecoverPasswordDTO, ErrorDetail, RecoverPasswordPayload>({
    mutationFn: authServices.recoverPassword,
    onSuccess: (data) => {
      queryClient.invalidateQueries()

      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.ACTION_IS_NOT_ALLOWED) {
        errorMessage = t('api:yourAccountIsDeleted')
      }

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (code === ApiErrorCode.VERIFICATION_CODE_INVALID) {
        errorMessage = t('api:validationErrors.verificationCodeInvalid')
      }

      if (code === ApiErrorCode.VERIFICATION_CODE_EXPIRED) {
        errorMessage = t('api:validationErrors.verificationCodeExpired')
      }

      if (options?.onError) {
        options.onError({ ...err, errorMessage, code })
      }
    },
  })
}
